import { Helmet } from "react-helmet-async";

const SITE = "https://www.universaltree.in";
const DEFAULT_TITLE = "Universal Tree — Trusted Home Services Near You";
const DEFAULT_DESC = "Book verified home service professionals — AC repair, plumbing, deep cleaning, painting & more. Fast, reliable, and rated.";
const DEFAULT_IMAGE = `${SITE}/theuniversaltree-logo.jpeg`;

export default function Seo({ title, description, image, url, noindex }) {
  const t = title ? `${title} | Universal Tree` : DEFAULT_TITLE;
  const d = description || DEFAULT_DESC;
  const i = image || DEFAULT_IMAGE;
  const u = url || SITE;
  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={u} />
      <meta property="og:image" content={i} />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={i} />
      <link rel="canonical" href={u} />
    </Helmet>
  );
}
